"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var FieldErrorShelf = /** @class */ (function () {
    function FieldErrorShelf() {
        this.fieldErrors = [];
        mobx_1.makeAutoObservable(this);
    }
    FieldErrorShelf.prototype.getFieldError = function (field) {
        var index = this.fieldErrors.findIndex(function (error) { return error.field === field; });
        if (index > -1) {
            return this.fieldErrors[index].message;
        }
        return null;
    };
    FieldErrorShelf.prototype.hasFieldError = function (field) {
        return this.fieldErrors.findIndex(function (error) { return error.field === field; }) > -1;
    };
    FieldErrorShelf.prototype.addError = function (error) {
        this.fieldErrors = tslib_1.__spreadArray(tslib_1.__spreadArray([], this.fieldErrors), [error]);
    };
    FieldErrorShelf.prototype.addErrors = function (errors) {
        this.fieldErrors = tslib_1.__spreadArray(tslib_1.__spreadArray([], this.fieldErrors), errors);
    };
    FieldErrorShelf.prototype.clearErrors = function () {
        this.fieldErrors = [];
    };
    FieldErrorShelf.prototype.cleanAndAddErrors = function (errors) {
        this.clearErrors();
        this.addErrors(errors);
    };
    return FieldErrorShelf;
}());
exports.default = FieldErrorShelf;
